<template>
  <div
    class="col-md-3 col-sm-3 hidden-xs"
  
  >

  <h4
      id="title_top_sales"
      class="text-center"
    > </h4>
    <h4
      id="title_top_sales"
      class="text-center"
    >{{$t(titulo)}}</h4>
    <ul id="top5">
      <li
        v-for="(item, c) in eventos"
        :key="c"
      >
        <v-card
          flat
          :color="top5Color"
          :to="`/${$i18n.locale}/detalle/${item.cmsID}/${item.Recinto[0].Id}`"
        >
          <v-container
            fluid
            class="pa-0"
          >
            <v-layout align-content-center class="color-fondo">
              <v-flex >
                <v-img
                :src="miImagen(item, configuracion.imagen)"
                  :aspect-ratio="imagen.ratio"
                  cover
                  width="50px"
                >
                </v-img>
              </v-flex>
              <v-flex
                xs11
                style="background: #FFD300"
              >
                <v-card
                  class="pl-2"
                  flat
                  :color="top5Color"
                >
                  <v-layout
                    column
                    fill-height
                  >
                    <b class="text-wrap">{{item.Nombre}} </b>
                    <i class="text-wrap">{{item.Poblacion[0].Nombre}}</i>

                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>

          </v-container>
        </v-card>
      </li>

    </ul>
    <div v-if="$i18n.locale == 'eu'">
      <br><br>
      <img src="../../assets/bannerKoner-KB-web-entradas-512x723_eus.jpg" class="img-responsive"
        alt="Kutxabank Korner banner">
      <br><br>
      <img src="../../assets/siguenos-rrss-KB-web-entradas-512x301_eus.jpg" class="img-responsive"
        alt="Kutxabank redes sociales">
      <br><br>
    </div>

    <div v-else>
      <br><br>
      <img src="../../assets/bannerKorner-KB-web-entradas-512x723-ES.jpg" class="img-responsive"
        alt="Kutxabank Korner banner">
      <br><br>
      <img src="../../assets/siguenos-rrss-web-entradas-512x301-ES.jpg" class="img-responsive"
        alt="Síguenos en redes Kutxabank">
      <br><br>
    </div>


  </div>
</template>
<style>
#top ul li {
  height: unset !important;
}

.color-fondo {
  background-color: #ffd300;
}
</style>

<script>
import { globales } from "../comunes";

export default {
  mixins: [globales],
  props: ["seccion"],
  computed: {
    seccionActual() {
      const secciones = this.layoutSecciones;
      // console.log("Secciones existes todas", this.layoutSecciones);
      const seccion = this.seccion;
      if (!secciones.hasOwnProperty(seccion)) {
        // console.log("Seccion no existe", seccion);
      }
      return this.layoutSecciones[this.seccion];
    },
    eventos() {
      // console.log("mi seccion actual existes", this.seccionActual);
      const secciones = this.$store.state.layout.secciones;
      const seccionActual = secciones[this.seccion]
        ? secciones[this.seccion]
        : null;
      const visibles = this.configuracion.visibles;
      const items = seccionActual["items"]
        ? seccionActual.items.slice(0, visibles)
        : [];
      const eventosJanto = this.$store.state.eventosJanto;
      const ahora = this.Hoy.ahora;

      const misEventos = items.map(evento => {
        if (eventosJanto[evento]) {
          const item = eventosJanto[evento];

          const id = item.webId;
          const itemWeb = this.$store.state.itemsWeb.find(i => i.id == id);
          console.log("itemWeb", itemWeb, id);
          if (itemWeb) {
            item.cms = itemWeb;
          }

          if (item.FFinVentaMax > ahora && item.FInicioVentaMin < ahora) {
            return item;
          }
        }
      });

      return misEventos.filter(e => e);
    },
    configuracion() {
      return this.seccionActual.configuracion;
    },
    titulo() {
      if (this.configuracion.labelVisible) {
        return this.configuracion.titulo;
      }
    },
    imagen() {
      const src = this.configuracion.imagen;
      const ratio = this.ratios[src];

      return {
        src,
        ratio,
      };
    },
    disposicion() {
      return this.configuracion.columnas;
    },
    // resto() {
    //   const numero = this.configuracion.visibles;
    //   return this.seccionActual.eventos.slice(numero);
    // },
  },
};
</script>
